import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import LanguageContainer from "../../../Translation/LanguageContainer";

import Button from '@material-ui/core/Button';
import { saveAs } from 'file-saver';
const XLSX = require ("xlsx");

class KeySwitch extends Component {
    public state = {
        keySwitch: false,
        translations: []
    }

    public componentWillMount() {
        this.setState({
            keySwitch: this.props.app.isLanguageKeySwitchOn
        });
    }

    public handleMissingTranslations = () => {
        const languages = Object.keys(LanguageContainer.languages[0].language)?.map(lang => {
            return {
                key: lang,
                EN: LanguageContainer.languages[0].language[lang],
                NL: LanguageContainer.languages[1].language[lang],
            }
        })
        this.setState({
            translations: [...languages]
        })
    }

    public handleTranslationChange = (event, key, language) => {
        const value = event?.target?.value;
        if (language?.toLowerCase() === "en") {
            const updatedErr = this.state.translations.map(error => {
                if (error?.key === key) {
                    error.EN = value;
                    return error;
                }
                return error;
            });
            LanguageContainer.languages[0].language[key] = value;
            this.setState({
                translations: [...updatedErr]
            })
        }
        if (language?.toLowerCase() === "nl") {
            const updatedErr = this.state.translations.map(error => {
                if (error?.key === key) {
                    error.EN = value;
                    return error;
                }
                return error;
            });
            LanguageContainer.languages[1].language[key] = value;
            this.setState({
                translations: [...updatedErr]
            })
        }
        this.forceUpdate();
    }

    protected saveBook = (s) => {
		var buf = new ArrayBuffer(s.length);
		var view = new Uint8Array(buf);
		for (var i = 0; i < s.length; i++) {
			view[i] = s.charCodeAt(i) & 0xff;
		}
		return buf;
	}

    public handleDownloadTranslations = (lang) => {
        let data = {}
        if (lang === "english") {
            data = LanguageContainer.languages[0].language;
        }
        if (lang === "dutch") {
            data = LanguageContainer.languages[1].language;
        }

        const translationSpreadsheet = XLSX.utils.book_new();
        translationSpreadsheet.SheetNames.push(`${lang} translation`);
        const sheetFromArrayData = XLSX.utils.aoa_to_sheet(Object.entries(data));
        translationSpreadsheet.Sheets[`${lang} translation`] = sheetFromArrayData;
        const book = XLSX.write(translationSpreadsheet, { bookType: "xlsx", type: "binary" });

        saveAs(
            new Blob([this.saveBook(book)], { type: "application/octet-stream" }),
            `${lang} translation.xlsx`
        );
    }

    render() {
        return (
            <div style={{margin: "60px 0 0 90px"}}>
                <Button
                    color="primary"
                    onClick={this.handleMissingTranslations}
                    variant="outlined"
                    style={{textAlign: "center", marginRight: "20px"}}
                >
                    {this.trans("button/show-translations")}
                </Button>
                <Button
                    color="primary"
                    onClick={this.handleDownloadTranslations.bind(this, "english")}
                    variant="outlined"
                    style={{textAlign: "center", marginRight: "20px"}}
                >
                    Download EN translations
                </Button>
                <Button
                    color="primary"
                    onClick={this.handleDownloadTranslations.bind(this, "dutch")}
                    variant="outlined"
                    style={{textAlign: "center", marginRight: "20px"}}
                >
                    Download NL translations
                </Button>
                {this.state.translations.length > 0 && (
                    this.state.translations.map(translation => (
                        <div>
                            <p style={{margin: 0}}>Key: {translation?.key}</p>
                            EN: <input
                                value={translation?.EN}
                                onChange={(event) => this.handleTranslationChange(event, translation?.key, "en")}
                                style={{width: "100%"}}
                            />
                            NL: <input
                                value={translation?.NL}
                                onChange={(event) => this.handleTranslationChange(event, translation?.key, "nl")}
                                style={{width: "100%"}}
                            />
                            -------------------
                        </div>
                    ))
                )}
            </div>
        )
    }
}

const mapStateToProps = state => {
  return {
    app: state.app
  };
};

export default connect(mapStateToProps)(
  KeySwitch
);
